export const LicenseDisputeReasons = {
  INCORRECT_DEPENDENCY_VERSION_REPORTED: 'INCORRECT_DEPENDENCY_VERSION_REPORTED',
  LICENSE_DETECTION_FALSE_POSITIVE: 'LICENSE_DETECTION_FALSE_POSITIVE',
  MULTI_OR_DUAL_LICENSED: 'MULTI_OR_DUAL_LICENSED',
};

export const LicenseDisputeReasonLabels = {
  INCORRECT_DEPENDENCY_VERSION_REPORTED: 'Incorrect dependency version reported',
  LICENSE_DETECTION_FALSE_POSITIVE: 'License detection false positive',
  MULTI_OR_DUAL_LICENSED: 'Multi or dual licensed',
};

export type LicenseDisputeReasonsKey = keyof typeof LicenseDisputeReasonLabels;
export type LicenseDisputeReasonsType = typeof LicenseDisputeReasons[keyof typeof LicenseDisputeReasons];

export type LicenseDispute = {
  id: number;
  createdBy: number;
  createdAt: Date;
  resolvedBy: number | null;
  resolvedAt: Date | null;
  licenseId: string;
  disputedIssueId: number;
  reason: LicenseDisputeReasonsType;
  comment: string | null;
}
